import { render, staticRenderFns } from "./ColumnCentered.vue?vue&type=template&id=299d138c"
import script from "./ColumnCentered.vue?vue&type=script&lang=ts"
export * from "./ColumnCentered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports